import PropTypes from 'prop-types';
import React from 'react';
import CompanyPageLayout from '../../../components/CompanyPages/CompanyPageLayout/CompanyPageLayout';
import JobResultLayout from '../../../components/JobV3/JobResultLayout/JobResultLayout';
import JobSearchBar from '../../../components/JobV3/JobSearchBar/JobSearchBar';
import LeftRailContent from '../../../components/LeftRailLayout/LeftRailContent/LeftRailContent';
import LeftRailLayout from '../../../components/LeftRailLayout/LeftRailLayout';
import {
    ATTRIBUTION_MODE_CHERRYPICK,
    LOAD_TYPE_PAGINATION,
} from '../../../contexts/AbstractContext';
import { JobContextProvider } from '../../../contexts/JobContext';
import { PageContext } from '../../../contexts/ContextCreator';
import { googleAnalytic } from '../../googeAnalyticHelper';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
    PAGE_TABS,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import './CompanyJob.scss';

export default class CompanyJob extends React.PureComponent {
    componentDidMount() {
        googleAnalytic('CompanyView', 'JobsV3', this.props.company.companyName);
    }

    render() {
        const { pageProps, isLoggedIn, jobProfileSnippet } = this.context;
        const { featureFlags, session } = pageProps;

        const {
            company,
            jobSearchBar,
            pagination,
            total,
            companyJobUrl,
            userJobProfile,
            page,
            limit,
            filters,
            enableAroundRadius,
            jobs,
            queryID,
        } = this.props;

        const contextProps = { session };

        const title = jobSearchBar.location
            ? `Jobs at ${company.companyName} in ${jobSearchBar.location}`
            : `Jobs at ${company.companyName}`;

        const isAuthenticatedUser = isLoggedIn();
        const showProfileCTA = !(
            isAuthenticatedUser && jobProfileSnippet.isCompleted
        );

        return (
            <div className="page-JobV3-CompanyJob">
                <SnowplowPageViewTracker
                    pageCompanyId={this.props.company.companyId}
                    pageEntityId={this.props.company.companyId}
                    pageSection={PAGE_VIEW_SECTIONS.COMPANY_PROFILE}
                    pageTab={PAGE_TABS.COMPANY_JOBS}
                    pageType={PAGE_VIEW_TYPES.COLLECTION}
                />
                <JobContextProvider
                    {...contextProps}
                    attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
                    jobsTotal={total}
                    content={jobs}
                    jobSearchBar={jobSearchBar}
                    pagination={pagination}
                    userJobProfile={userJobProfile}
                    type="infinite-scroll"
                    enableAroundRadius={enableAroundRadius}
                    page={page}
                    limit={limit}
                    activeFilters={filters}
                    renderType={LOAD_TYPE_PAGINATION}
                    baseUrl={companyJobUrl}
                    searchQueryId={queryID}
                    fromCompanyJobsPage
                >
                    <CompanyPageLayout
                        company={company}
                        jobSearchBar={jobSearchBar}
                        additionalTopBannerOnlyShownList={['profile-cta']}
                    >
                        <div>
                            <JobSearchBar
                                companyUrl={companyJobUrl}
                                {...jobSearchBar}
                            />
                            <LeftRailLayout>
                                <LeftRailLayout.LeftRail>
                                    <LeftRailContent
                                        allowProfileCTA={showProfileCTA}
                                    />
                                </LeftRailLayout.LeftRail>
                                <LeftRailLayout.MainContent>
                                    <JobResultLayout
                                        setAlertEnabled={false}
                                        title={title}
                                        shouldShowHelpText
                                        showFilters={false}
                                        featureFlags={featureFlags}
                                        hideJobResultsCTA
                                    />
                                </LeftRailLayout.MainContent>
                            </LeftRailLayout>
                        </div>
                    </CompanyPageLayout>
                </JobContextProvider>
            </div>
        );
    }
}

CompanyJob.contextType = PageContext;

CompanyJob.defaultProps = {
    total: 0,
    employerHeaderProps: {},
    companyJobUrl: '',
    enableAroundRadius: false,
    page: 1,
    limit: 0,
    company: {},
    userJobProfile: {},
    filters: {},
    queryID: '',
};

CompanyJob.propTypes = {
    /**
     * array of jobs
     */
    jobs: PropTypes.arrayOf([PropTypes.object]).isRequired,
    /**
     * pagination
     */
    pagination: PropTypes.shape({
        prevUrl: PropTypes.string,
        nextUrl: PropTypes.string,
    }).isRequired,
    /**
     * total number of jobs
     */
    total: PropTypes.number,
    /**
     * company header props
     */
    employerHeaderProps: PropTypes.oneOf(PropTypes.object),
    /**
     * job search bar data
     */
    jobSearchBar: PropTypes.oneOf(PropTypes.object).isRequired,
    /**
     *  company url
     */
    companyJobUrl: PropTypes.string,
    enableAroundRadius: PropTypes.bool,
    /**
     * pageNumber for pagination
     */
    page: PropTypes.number,
    /**
     * number limit for search
     */
    limit: PropTypes.number,
    company: PropTypes.oneOf(PropTypes.object),
    userJobProfile: PropTypes.oneOf(PropTypes.object),
    filters: PropTypes.oneOf(PropTypes.object),
    queryID: PropTypes.string,
};
